<template>
  <div>
    <div class="ECMonitor-title">
      <div>{{ $t("BillingServices.BillingRules") }}</div>
    </div>
    <Tabs v-model="activeName" @on-click="handleClickTabs">
      <!-- 数据处理规则 -->
      <TabPane :label="$t('BillingServices.Dataprocessingrules')" name="1">
        <Form :model="searchDataDeal" inline>
          <FormItem label="" v-if="companyId == 1">
            <Select
              v-model="searchDataDeal.companyId"
              filterable
              :placeholder="$t('alarms.common.pleaseSelectCompany')"
              :transfer="true"
            >
              <Option
                :value="item.id"
                v-for="item in companyList"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
          <FormItem label="">
            <Input
              v-model="searchDataDeal.ruleName"
              :placeholder="$t('BillingServices.Querybyrulename')"
              search
              @on-search="getDealData"
            ></Input>
          </FormItem>
          <FormItem label="">
            <Button type="primary" @click="getDealData">{{
              $t("BillingServices.select")
            }}</Button>
            <Button type="primary" @click="handleAddRule">{{
              $t("BillingServices.AddRule")
            }}</Button>
          </FormItem>
        </Form>
        <Table
          :columns="dataDealColumns"
          :data="dataDealTableData"
          :no-data-text="$t('common.noData')"
          style="margin-bottom:10px"
        >
          <template slot-scope="{ row, index }" slot="operation">
            <Button
              type="primary"
              size="small"
              @click="handleDataDealOperData(row)"
              >{{ $t("BillingServices.Operationlog") }}</Button
            >
            <Button type="primary" size="small" @click="handleEditRuleData(row)">{{
                $t("BillingServices.edit")
              }}</Button>
            <Button type="error" size="small" @click="handleDataDealDel(row)">{{
              $t("BillingServices.del")
            }}</Button>
          </template>
        </Table>
        <div style="margin-bottom:70px">
          <Page
            style="margin-bottom:10px"
            :total="dealDatatotal"
            :current="searchDataDeal.pageNum"
            :page-size="searchDataDeal.pageSize"
            :transfer="true"
            show-sizer
            @on-change="handleChangeSearchDataDealPageNum"
            @on-page-size-change="handleChangeSearchDataDealPageSize"
          ></Page>
        </div>
      </TabPane>
      <!-- 标签处理规则 -->
      <TabPane :label="$t('BillingServices.Labelhandlingrules')" name="2">
        <Form :model="searchDataLabel" inline>
          <FormItem label="" v-if="companyId == 1">
            <Select
              v-model="searchDataLabel.companyId"
              filterable
              :placeholder="$t('alarms.common.pleaseSelectCompany')"
              :transfer="true"
            >
              <Option
                :value="item.id"
                v-for="item in companyList"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
          <FormItem label="">
            <Input
              v-model="searchDataLabel.billingTagRuleName"
              :placeholder="$t('BillingServices.Querybyrulename')"
              search
              @on-search="getLabelData"
            ></Input>
          </FormItem>
          <FormItem label="">
            <Button type="primary" @click="getLabelData">{{
              $t("BillingServices.select")
            }}</Button>
            <Button type="primary" @click="handleAddLabelRule">{{
              $t("BillingServices.AddRule")
            }}</Button>
          </FormItem>
        </Form>
        <Table
          :columns="dataLabelColumns"
          :data="dataLabelTableData"
          :no-data-text="$t('common.noData')"
          style="margin-bottom:10px"
        >
          <template slot-scope="{ row, index }" slot="operation">
            <Button
              type="primary"
              size="small"
              @click="handleDataDealOperData(row)"
              >{{ $t("BillingServices.Operationlog") }}</Button
            >
            <Button type="primary" size="small" @click="handleEditLabelRuleData(row)">{{
                $t("BillingServices.edit")
              }}</Button>
            <Button
              type="error"
              size="small"
              :disabled="row.disable == false"
              @click="handleDataDealDel(row)"
              >{{ $t("BillingServices.del") }}</Button
            >
          </template>
        </Table>
        <div style="margin-bottom:70px">
          <Page
            style="margin-bottom:10px"
            :total="LabelDatatotal"
            :current="searchDataLabel.pageNum"
            :page-size="searchDataLabel.pageSize"
            :transfer="true"
            show-sizer
            @on-change="handleChangesearchDataLabelPageNum"
            @on-page-size-change="handleChangesearchDataLabelPageSize"
          ></Page>
        </div>
      </TabPane>
    </Tabs>
    <!-- 编辑数据规则弹窗 -->
    <Modal
      v-model="editRuleModal"
      :title="
        editStatus
          ? $t('BillingServices.EditProcessingRule')
          : $t('BillingServices.AddProcessingRule')
      "
      :mask-closable="false"
      @on-cancel="handleDataDealCancel"
    >
      <Form
        :model="editRuleData"
        :label-width="150"
        ref="editRuleRef"
        :rules="dataDealRule"
      >
        <FormItem
          :label="$t('BillingServices.company')"
          v-if="companyId == 1"
          prop="companyId"
        >
          <Select
            v-model="editRuleData.companyId"
            filterable
            :placeholder="$t('alarms.common.pleaseSelectCompany')"
            :transfer="true"
            style="width: 200px"
            :disabled="editStatus"
            @on-change="handleChangeCompanyId"
          >
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem :label="$t('BillingServices.ruleName')" prop="ruleName">
          <Input
            v-model="editRuleData.ruleName"
            :disabled="editStatus"
            style="width: 200px"
            @on-blur="handleBlur"
          ></Input>
        </FormItem>
        <FormItem
          :label="$t('BillingServices.Cloudplatformtype')"
          prop="cloudPlatformsType"
        >
          <Select
            v-model="editRuleData.cloudPlatformsType"
            filterable
            :disabled="editStatus"
            :transfer="true"
            style="width: 200px"
            @on-change="handleChangeData"
          >
            <Option
              :value="item.id"
              v-for="item in CloudplatformtypeList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem
          :label="$t('BillingServices.Billingdatasource')"
          prop="accountList"
        >
          <Select
            v-model="editRuleData.accountList"
            filterable
            multiple
            style="width: 200px"
            :transfer="true"
          >
            <Option
              :value="item.id"
              v-for="item in BillingdatasourceList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <!-- 仅仅当云平台类型选择 aws时，显示 这个formitem -->
        <FormItem
          :label="$t('BillingServices.WhetherRIprocessingisrequired')"
          v-if="editRuleData.cloudPlatformsType == 0"
        >
          <RadioGroup v-model="editRuleData.needRi">
            <Radio :label="1">{{ $t('common.yes') }}</Radio>
            <Radio :label="0">{{ $t('common.no') }}</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem :label="$t('BillingServices.LabelRules')">
          <Select
            v-model="editRuleData.tagRuleIds"
            filterable
            :transfer="true"
            multiple
            style="width: 200px"
          >
            <Option
              :value="item.id"
              v-for="item in LabelRulesList"
              :key="item.id"
              >{{ item.ruleName }}</Option
            >
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="handleDataDealCancel" :disabled="isDisable"
          >{{ $t("OriginalBillEntry.cancel") }}
        </Button>
        <Button
          type="primary"
          v-if="!editStatus"
          @click="handleConfirmDataDeal"
          :disabled="isDisable"
          >{{ $t("BillingServices.add") }}
        </Button>
        <Button
          type="primary"
          v-else
          @click="handleConfirmDataDeal"
          :disabled="isDisable"
          >{{ $t("BillingServices.confirm") }}
        </Button>
      </div>
    </Modal>
    <!-- 编辑标签规则弹窗 -->
    <Modal
      width="700"
      v-model="editLabelRuleModal"
      :title="
        editStatus
          ? $t('BillingServices.editLabelRule')
          : $t('BillingServices.AddLabelRule')
      "
      :mask-closable="false"
      @on-cancel="handleDataLabelCancel"
    >
      <Form
        :model="editLabelRuleData"
        :label-width="120"
        ref="editLabelRuleRef"
        :rules="editLabelRules"
      >
        <FormItem
          :label="$t('BillingServices.company')"
          v-if="companyId == 1"
          prop="companyId"
        >
          <Select
            v-model="editLabelRuleData.companyId"
            filterable
            :placeholder="$t('alarms.common.pleaseSelectCompany')"
            :transfer="true"
            style="width: 200px"
            :disabled="editStatus"
          >
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem
          :label="$t('BillingServices.ruleName')"
          prop="billingTagRuleName"
        >
          <Input
            v-model="editLabelRuleData.billingTagRuleName"
            :disabled="editStatus"
            style="width: 200px"
            @on-blur="handleBlurCheckTagProcessRule"
          ></Input>
        </FormItem>
        <FormItem
          :label="$t('BillingServices.conditionsforexecution') + '：'"
          style="margin-bottom:0"
          required
        >
          <RadioGroup v-model="editLabelRuleData.executionCondition">
            <Radio :label="0">
              <span>{{ $t("BillingServices.Satisfyanyone") }}</span>
            </Radio>
            <Radio :label="1">
              <span>{{ $t("BillingServices.Meetall") }}</span>
            </Radio>
          </RadioGroup>
          <Tooltip
            max-width="350"
            :content="$t('BillingServices.tagRuleTooltip')"
          >
            <span style="margin-left:-10px;" class="tagSpan">
              <Icon type="ios-alert" style="color:red;font-size:16px" />
            </span>
          </Tooltip>
        </FormItem>
        <Row :gutter="16">
          <Col span="24">
            <FormItem label="" :label-width="100">
              <Row style="font-size:13px;">
                <Col span="10"><label>tagKey</label></Col>
                <Col span="10"><label>tagValue</label></Col>
              </Row>
              <div
                v-for="(item,
                index) in editLabelRuleData.executionConditionTagRuleItems"
                :key="index"
              >
                <Row :gutter="4" style="margin-bottom:20px;">
                  <Col span="10">
                    <FormItem
                      label=""
                      :prop="
                        'executionConditionTagRuleItems.' + index + '.tagKey'
                      "
                      :rules="[
                        {
                          required: true,
                          message: this.$t('BillingServices.PleaseentertagKey'),
                          trigger: 'blur'
                        },
                        {
                          pattern: /^([\u4e00-\u9fa5a-zA-Z0-9]|[\u4e00-\u9fa5a-zA-Z0-9].*[\u4e00-\u9fa5a-zA-Z0-9])$/,
                          message: this.$t('BillingServices.tagNoSpecialChar'),
                          trigger: 'blur'
                        }
                      ]"
                    >
                      <Input
                        type="text"
                        v-model="item.tagKey"
                        :placeholder="$t('BillingServices.PleaseentertagKey')"
                      ></Input>
                    </FormItem>
                  </Col>
                  <Col span="10">
                    <FormItem
                      label=""
                      :prop="
                        'executionConditionTagRuleItems.' + index + '.tagValue'
                      "
                      :rules="[
                        {
                          pattern: /^([\u4e00-\u9fa5a-zA-Z0-9]|[\u4e00-\u9fa5a-zA-Z0-9].*[\u4e00-\u9fa5a-zA-Z0-9])$/,
                          message: this.$t('BillingServices.tagNoSpecialChar'),
                          trigger: 'blur'
                        },
                        {
                          required: true,
                          message: this.$t('BillingServices.PleaseentertagValue'),
                          trigger: 'blur'
                        }
                      ]"
                    >
                      <Input
                        type="text"
                        v-model="item.tagValue"
                        :placeholder="$t('BillingServices.PleaseentertagValue')"
                      ></Input>
                    </FormItem>
                  </Col>
                  <Col span="4">
                    <Button @click="handleDelTagObj(index)">{{ $t('BillingServices.del') }}</Button>
                  </Col>
                </Row>
              </div>
              <Row>
                <Col span="20">
                  <Button
                    type="dashed"
                    long
                    @click="handleAddObj"
                    icon="md-add"
                    style="width:100%"
                    >{{ $t('BillingServices.AddLabel') }}</Button
                  >
                </Col>
              </Row>
            </FormItem>
          </Col>
        </Row>

        <FormItem :label="$t('BillingServices.executeActionLabel')" style="margin-bottom:0" required>
        </FormItem>
        <Row :gutter="16">
          <Col span="24">
            <FormItem label="" :label-width="100">
              <Row style="font-size:13px;">
                <Col span="10"><label>tagKey</label></Col>
                <Col span="10"><label>tagValue</label></Col>
              </Row>
              <div
                v-for="(item,
                index) in editLabelRuleData.executionActionTagRuleItems"
                :key="index"
              >
                <Row :gutter="4" style="margin-bottom:20px;">
                  <Col span="10">
                    <FormItem
                      label=""
                      :prop="'executionActionTagRuleItems.' + index + '.tagKey'"
                      :rules="[
                        {
                          required: true,
                          message: this.$t('BillingServices.PleaseentertagKey'),
                          trigger: 'blur'
                        },
                        {
                          pattern: /^([\u4e00-\u9fa5a-zA-Z0-9]|[\u4e00-\u9fa5a-zA-Z0-9].*[\u4e00-\u9fa5a-zA-Z0-9])$/,
                          message: this.$t('BillingServices.tagNoSpecialChar'),
                          trigger: 'blur'
                        }
                      ]"
                    >
                      <Input
                        type="text"
                        v-model="item.tagKey"
                        :placeholder="$t('BillingServices.PleaseentertagKey')"
                      ></Input>
                    </FormItem>
                  </Col>
                  <Col span="10">
                    <FormItem
                      label=""
                      :prop="
                        'executionActionTagRuleItems.' + index + '.tagValue'
                      "
                      :rules="[
                        {
                          pattern: /^([\u4e00-\u9fa5a-zA-Z0-9]|[\u4e00-\u9fa5a-zA-Z0-9].*[\u4e00-\u9fa5a-zA-Z0-9])$/,
                          message: this.$t('BillingServices.tagNoSpecialChar'),
                          trigger: 'blur'
                        },
                        {
                          required: true,
                          message: this.$t('BillingServices.PleaseentertagValue'),
                          trigger: 'blur'
                        }
                      ]"
                    >
                      <Input
                        type="text"
                        v-model="item.tagValue"
                        :placeholder="$t('BillingServices.PleaseentertagValue')"
                      ></Input>
                    </FormItem>
                  </Col>
                  <Col span="4">
                    <Button @click="handleDelTagObj1(index)">{{ $t('BillingServices.del') }}</Button>
                  </Col>
                </Row>
              </div>
              <Row>
                <Col span="20">
                  <Button
                    type="dashed"
                    long
                    @click="handleAddObj1"
                    icon="md-add"
                    style="width:100%"
                    >{{ $t('BillingServices.AddLabel') }}</Button
                  >
                </Col>
              </Row>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button @click="handleDataLabelCancel" :disabled="isDisable"
          >{{ $t("OriginalBillEntry.cancel") }}
        </Button>
        <Button
          type="primary"
          v-if="!editStatus"
          @click="handleConfirmLabelDeal"
          :disabled="isDisable"
          >{{ $t("BillingServices.add") }}
        </Button>
        <Button
          type="primary"
          v-else
          @click="handleConfirmLabelDeal"
          :disabled="isDisable"
          >{{ $t("BillingServices.confirm") }}
        </Button>
      </div>
    </Modal>
    <!-- 操作日志弹窗 -->
    <Modal
      footer-hide
      width="800px"
      v-model="operLogModal"
      :title="$t('BillingServices.Operationlog')"
    >
      <Table
        :columns="operLogColumns"
        :data="operLogTableData"
        :no-data-text="$t('common.noData')"
        style="margin-bottom:10px"
      >
      </Table>
      <!-- <Page
        :total="operLogTotal"
        :current="operLogData.pageNum"
        :page-size="operLogData.pageSize"
        :transfer="true"
        show-sizer
        @on-change="handleChangePageNumByOperLog"
        @on-page-size-change="handleChangePageSizeByOperLog"
      ></Page> -->
    </Modal>
    <!-- 删除弹窗 -->
    <Modal v-model="delModal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ RowName }}
          {{ $t("alarms.common.what") }}?
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          @click="handleConfirmDel"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}
        </Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import log from "../../../api/log";
import { getCookie } from "../../../utils/cookieUtil";
export default {
  data() {
    return {
      operLogModal: false,
      delModal: false,
      isDisable: false,
      editRuleModal: false,
      editStatus: false,
      editLabelRuleModal: false,
      companyId: getCookie(global.companyId),
      activeName: "1",
      searchDataDeal: {
        companyId: 1,
        ruleName: "",
        pageNum: 1,
        pageSize: 10
      },
      searchDataLabel: {
        companyId: 1,
        billingTagRuleName: "",
        pageNum: 1,
        pageSize: 10
      },
      operLogData: {
        pageNum: 1,
        pageSize: 10
      },
      editRuleData: {
        id: "",
        companyId: undefined,
        ruleName: "",
        cloudPlatformsType: "",
        accountList: [],
        needRi: 1,
        tagRuleIds: []
      },
      // 编辑标签规则shuj
      editLabelRuleData: {
        id: "",
        companyId: null,
        billingTagRuleName: "",
        executionCondition: 0,
        executionConditionTagRuleItems: [
          {
            ruleType: 0,
            tagKey: "",
            tagValue: ""
          }
        ],
        executionActionTagRuleItems: [
          {
            ruleType: 1,
            tagKey: "",
            tagValue: ""
          }
        ]
      },
      RowName: "",
      companyList: [],
      LabelRulesList: [],
      BillingdatasourceList: [],
      CloudplatformtypeList: [],
      dataDealTableData: [],
      dealDatatotal: 0,
      operLogTotal: 0,
      LabelDatatotal: 0,
      // 数据处理表头
      dataDealColumns: [
        {
          title: this.$t("BillingServices.companyName"),
          key: "companyName",
          minWidth: 100
        },
        {
          title: this.$t("BillingServices.ruleName"),
          key: "ruleName",
          minWidth: 100
        },
        {
          title: this.$t("BillingServices.Cloudplatformtype"),
          key: "cloudPlatformsName",
          minWidth: 100
        },
        {
          title: this.$t("BillingServices.Billingdatasource"),
          key: "accountName",
          minWidth: 100
        },
        {
          title: this.$t("BillingServices.Appliedlabelrules"),
          key: "tagRuleName",
          minWidth: 100
        },
        {
          title: this.$t("ticket.list.operation"),
          key: "",
          minWidth: 100,
          slot: "operation"
        }
      ],
      // 操作日志表头
      operLogColumns: [
        {
          title: this.$t("BillingServices.Operationmodule"),
          key: "billingFunctionModule",
          minWidth: 100
        },
        {
          title: this.$t("BillingServices.Operationfield"),
          key: "operationField",
          minWidth: 100
        },
        {
          title: this.$t("BillingServices.Originalvalue"),
          key: "operationOriginValue",
          minWidth: 100
        },
        {
          title: this.$t("BillingServices.Newvalue"),
          key: "operationNewValue",
          minWidth: 100
        },
        {
          title: this.$t("BillingServices.Operator"),
          key: "createdBy",
          minWidth: 100
        },
        {
          title: this.$t("BillingServices.UpdateTime"),
          key: "createdTime",
          minWidth: 100
        }
      ],
      operLogTableData: [],
      // 数据处理rule
      dataDealRule: {
        companyId: [
          {
            required: true,
            message: this.$t("alarms.common.pleaseSelectCompany"),
            trigger: "change",
            type: "number"
          }
        ],
        ruleName: [
          {
            required: true,
            message: this.$t('BillingServices.pleaseInputRuleName'),
            trigger: "blur"
          }
        ],
        cloudPlatformsType: [
          {
            required: true,
            message: this.$t('BillingServices.pleaseSelectCloudPlatformType')
          }
        ],
        accountList: [
          {
            required: true,
            message: this.$t('BillingServices.pleaseSelectBillingDataSource'),
            trigger: "blur",
            type: "array"
          }
        ]
      },
      // 标签处理rule
      editLabelRules: {
        companyId: [
          {
            required: true,
            message: this.$t("alarms.common.pleaseSelectCompany"),
            trigger: "change",
            type: "number"
          }
        ],
        billingTagRuleName: [
          {
            required: true,
            message: this.$t('BillingServices.pleaseInputRuleName'),
            trigger: "blur"
          }
        ]
      },
      // 标签处理表头
      dataLabelColumns: [
        {
          title: this.$t("BillingServices.companyName"),
          key: "companyName",
          minWidth: 100
        },
        {
          title: this.$t("BillingServices.ruleName"),
          key: "ruleName",
          minWidth: 100
        },
        {
          title: this.$t("BillingServices.conditionsforexecution"),
          key: "executionConditionName",
          minWidth: 100
        },
        {
          title: this.$t("BillingServices.Conditioncontent"),
          key: "executionConditionContent",
          minWidth: 100
        },
        {
          title: this.$t("BillingServices.Executeaction"),
          key: "executionAction",
          minWidth: 100
        },
        {
          title: this.$t("ticket.list.operation"),
          key: "",
          minWidth: 100,
          slot: "operation"
        }
      ],
      dataLabelTableData: [],
      getRowData: {},
      nameCheckStatus: false
    };
  },
  methods: {
    handleChangeData() {
      this.queryAccountsByCompanyId();
    },
    handleChangeCompanyId() {
      this.editRuleData.accountList = [];
      this.editRuleData.tagRuleIds = [];
      this.editRuleData.cloudPlatformsType = "";
      this.queryBillingTagRule();
      // this.queryAccountsByCompanyId();
    },
    // 失去焦点时调用去重接口，保存时也需要调用
    handleBlur() {
      if (!this.editRuleData.ruleName) {
        return;
      }
      this.$api.originalBillEntry
        .duplicateCheckSourceDataProcessRule({
          ruleName: this.editRuleData.ruleName,
          companyId: this.editRuleData.companyId
        })
        .then(res => {
          this.nameCheckStatus = false;
        })
        .catch(err => {
          this.nameCheckStatus = true;
          this.$Message.error(this.$t('BillingServices.ruleNameDuplicate'));
        });
    },
    handleBlurCheckTagProcessRule() {
      if (!this.editLabelRuleData.billingTagRuleName) {
        return;
      }
      this.$api.originalBillEntry
        .duplicateCheckTagProcessRule({
          billingTagRuleName: this.editLabelRuleData.billingTagRuleName,
          companyId: this.editLabelRuleData.companyId
        })
        .then(res => {
          this.nameCheckStatus = false;
        })
        .catch(err => {
          this.nameCheckStatus = true;
          this.$Message.error(this.$t('BillingServices.ruleNameDuplicate'));
        });
    },
    handleClickTabs() {},
    //  获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
          this.searchDataDeal.companyId = this.companyList[0].id;
          this.searchDataLabel.companyId = this.companyList[0].id;
        });
    },
    // 数据处理规则-添加规则弹窗
    handleAddRule() {
      this.editStatus = false;
      this.editRuleModal = true;
      this.queryCloudPlatforms();
      this.queryBillingTagRule();
    },
    // 标签处理规则-添加规则弹窗
    handleAddLabelRule() {
      this.editStatus = false;
      this.editLabelRuleModal = true;
    },
    // 显示操作日志弹窗 请求接口
    handleDataDealOperData(row) {
      this.operLogModal = true;
      this.getOperLogData(row.id);
    },
    // 显示删除弹窗
    handleDataDealDel(row) {
      this.delModal = true;
      this.getRowData = row;
      this.RowName = row.name;
    },
    // 数据处理规则 getdata
    getDealData() {
      this.$api.originalBillEntry
        .queryPagingBillingDataRule(this.searchDataDeal)
        .then(res => {
          this.dataDealTableData = res.data.records;
          this.dealDatatotal = res.data.total;
        });
    },
    // 标签处理规则 getdata
    getLabelData() {
      this.$api.originalBillEntry
        .queryPagingBillingTagRule(this.searchDataLabel)
        .then(res => {
          this.dataLabelTableData = res.data.records;
          this.LabelDatatotal = res.data.total;
        });
    },
    // 操作日志 getdata
    getOperLogData(id) {
      if (this.activeName == 1) {
        this.$api.originalBillEntry
          .queryOperationLogsbillingSourceDataProcessRule("id", id)
          .then(res => {
            this.operLogTableData = res.data;
          });
      } else {
        this.$api.originalBillEntry.queryOperationLogs("id", id).then(res => {
          this.operLogTableData = res.data;
        });
      }
    },
    // 数据处理分页
    handleChangeSearchDataDealPageNum(pageNum) {
      this.searchDataDeal.pageNum = pageNum;
      this.getDealData();
    },
    handleChangeSearchDataDealPageSize(pageSize) {
      this.searchDataDeal.pageSize = pageSize;
      this.getDealData();
    },
    // 标签处理分页
    handleChangesearchDataLabelPageNum(pageNum) {
      this.searchDataLabel.pageNum = pageNum;
      this.getLabelData();
    },
    handleChangesearchDataLabelPageSize(pageSize) {
      this.searchDataLabel.pageSize = pageSize;
      this.getLabelData();
    },
    // 操作日志分页
    // handleChangePageNumByOperLog(pageNum) {
    //   this.operLogData.pageNum = pageNum;
    //   this.getOperLogData();
    // },
    // handleChangePageSizeByOperLog(pageSize) {
    //   this.operLogData.pageSize = pageSize;
    //   this.getOperLogData();
    // },
    // 删除
    handleConfirmDel() {
      if (this.activeName == "1") {
        this.$api.originalBillEntry
          .deleteDataRule("id", this.getRowData.id)
          .then(res => {
            this.$Message.success(this.$t('common.deleteSuccess'));
            this.delModal = false;
            this.getDealData();
          });
      } else {
        this.$api.originalBillEntry
          .deleteTagRule("id", this.getRowData.id)
          .then(res => {
            this.$Message.success(this.$t('common.deleteSuccess'));
            this.delModal = false;
            this.getLabelData();
          });
      }
    },
    // 数据处理规则 点击规则名称 编辑回显数据请求接口
    handleEditRuleData(row) {
      this.editStatus = true;
      this.editRuleModal = true;
      this.getEditRuleData(row.id);
    },
    getEditRuleData(id) {
      this.queryCloudPlatforms();
      this.queryBillingTagRule();

      this.$api.originalBillEntry.getBillingDataRuleById("id", id).then(res => {
        this.editRuleData.id = res.data.id;
        this.editRuleData.companyId = res.data.companyId;
        this.editRuleData.ruleName = res.data.tagRuleName;
        this.editRuleData.cloudPlatformsType =
          res.data.billingCloudPlatformType;
        this.editRuleData.accountList = res.data.accountList;
        this.editRuleData.tagRuleIds = res.data.billingTagProcessRuleList;
        this.editRuleData.tagRuleIds = this.editRuleData.tagRuleIds.map(
          item => item.id
        );
        this.editRuleData.needRi = res.data.needRi ? 1 : 0;
        this.editRuleData.accountList = this.editRuleData.accountList.map(
          item => item.id
        );
        this.queryAccountsByCompanyId();
      });
    },
    // 标签处理规则 点击规则名称 编辑回显数据请求接口
    handleEditLabelRuleData(row) {
      this.editStatus = true;
      this.editLabelRuleModal = true;
      this.getEditLabelRuleData(row.id);
    },
    getEditLabelRuleData(id) {
      this.$api.originalBillEntry.getBillingTagRuleById("id", id).then(res => {
        this.editLabelRuleData.id = res.data.id;
        this.editLabelRuleData.companyId = res.data.companyId;
        this.editLabelRuleData.billingTagRuleName = res.data.ruleName;
        this.editLabelRuleData.executionActionTagRuleItems =
          res.data.executionActionTagRuleItems;
        this.editLabelRuleData.executionCondition = res.data.executionCondition;
        this.editLabelRuleData.executionConditionTagRuleItems =
          res.data.executionConditionTagRuleItems;
      });
    },
    // 数据处理取消
    handleDataDealCancel() {
      this.editRuleModal = false;
      (this.editRuleData = {
        companyId: "",
        ruleName: "",
        cloudPlatformsType: "",
        accountList: [],
        needRi: 1,
        tagRuleIds: []
      }),
        this.$refs.editRuleRef.resetFields();
    },
    // 标签处理 - 编辑规则弹窗 取消事件
    handleDataLabelCancel() {
      this.editLabelRuleModal = false;
      (this.editLabelRuleData = {
        companyId: "",
        billingTagRuleName: "",
        executionCondition: 0,
        executionConditionTagRuleItems: [
          {
            ruleType: 0,
            tagKey: "",
            tagValue: ""
          }
        ],
        executionActionTagRuleItems: [
          {
            ruleType: 1,
            tagKey: "",
            tagValue: ""
          }
        ]
      }),
        this.$refs.editLabelRuleRef.resetFields();
    },
    // 数据处理规则-编辑规则-弹窗 确认事件
    handleConfirmDataDeal() {
      this.$refs.editRuleRef.validate(valid => {
        if (valid) {
          if (this.editStatus == false) {
            this.handleBlur();
          }
          if (this.nameCheckStatus) {
            return;
          }
          this.$api.originalBillEntry
            .addOrUpdateDataRule(this.editRuleData)
            .then(res => {
              this.$Message.success(this.$t('common.operationSuccess'));
              this.getDealData();
              this.editRuleModal = false;
              this.handleDataDealCancel();
            });
        } else {
          this.$Message.error(this.$t('BillingServices.pleaseInputComplete'));
          this.editRuleModal = true;
          return;
        }
      });
    },
    // 标签处理规则-编辑规则-弹窗 确认事件
    handleConfirmLabelDeal() {
      this.$refs.editLabelRuleRef.validate(valid => {
        if (valid) {
          // 执行条件的校验
          let valArr = [];
          for (
            var i = 0;
            i < this.editLabelRuleData.executionConditionTagRuleItems.length;
            i++
          ) {
            if (
              valArr.includes(
                this.editLabelRuleData.executionConditionTagRuleItems[i]
                  .tagKey +
                  this.editLabelRuleData.executionConditionTagRuleItems[i]
                    .tagValue
              )
            ) {
              this.$Message.error(this.$t('BillingServices.duplicateConditionRow', { row: i + 1 }));
              this.addTagModal = true;
              return false;
            }
            valArr.push(
              this.editLabelRuleData.executionConditionTagRuleItems[i].tagKey +
                this.editLabelRuleData.executionConditionTagRuleItems[i]
                  .tagValue
            );
          }
          // 以下为执行动作校验
          let valArr1 = [];
          let valArr5 = [];
          for (
            var i = 0;
            i < this.editLabelRuleData.executionActionTagRuleItems.length;
            i++
          ) {
            if (
              valArr1.includes(
                this.editLabelRuleData.executionActionTagRuleItems[i].tagKey +
                  this.editLabelRuleData.executionActionTagRuleItems[i].tagValue
              )
            ) {
              this.$Message.error(this.$t('BillingServices.duplicateActionRow', { row: i + 1 }));
              this.addTagModal = true;
              return false;
            }
            if (
              valArr5.includes(
                this.editLabelRuleData.executionActionTagRuleItems[i].tagKey
              )
            ) {
              this.$Message.error(this.$t('BillingServices.duplicateActionFieldName'));
              this.addTagModal = true;
              return false;
            }
            valArr1.push(
              this.editLabelRuleData.executionActionTagRuleItems[i].tagKey +
                this.editLabelRuleData.executionActionTagRuleItems[i].tagValue
            );
            valArr5.push(
              this.editLabelRuleData.executionActionTagRuleItems[i].tagKey
            );
          }
          // 执行条件 与 执行动作 不一样判断，executionConditionTagRuleItems  executionActionTagRuleItems
          let valArr2 = [];
          for (
            var i = 0;
            i < this.editLabelRuleData.executionConditionTagRuleItems.length;
            i++
          ) {
            valArr2.push(
              this.editLabelRuleData.executionConditionTagRuleItems[i].tagKey +
                this.editLabelRuleData.executionConditionTagRuleItems[i]
                  .tagValue
            );
            for (
              var j = 0;
              j < this.editLabelRuleData.executionActionTagRuleItems.length;
              j++
            ) {
              if (
                valArr2.includes(
                  this.editLabelRuleData.executionActionTagRuleItems[j].tagKey +
                    this.editLabelRuleData.executionActionTagRuleItems[j]
                      .tagValue
                )
              ) {
                this.$Message.error(this.$t('BillingServices.actionConditionDuplicate'));
                this.addTagModal = true;
                return false;
              }
            }
          }
          if (this.editStatus == false) {
            this.handleBlurCheckTagProcessRule();
          }
          if (this.nameCheckStatus) {
            return;
          }
          this.$api.originalBillEntry
            .addOrUpdateTagRule(this.editLabelRuleData)
            .then(res => {
              this.$Message.success(this.$t('common.operationSuccess'));
              this.getLabelData();
              this.editLabelRuleModal = false;
              this.handleDataLabelCancel();
            });
        } else {
          this.$Message.error(this.$t('BillingServices.pleaseInputComplete'));
          this.editLabelRuleModal = true;
          return;
        }
      });
    },
    // 标签规则-添加标签-新增执行条件
    handleAddObj() {
      this.editLabelRuleData.executionConditionTagRuleItems.push({
        ruleType: 0,
        tagKey: "",
        tagValue: ""
      });
    },
    // 标签规则-添加标签-新增执行动作
    handleAddObj1() {
      this.editLabelRuleData.executionActionTagRuleItems.push({
        ruleType: 1,
        tagKey: "",
        tagValue: ""
      });
    },
    // 删除执行条件
    handleDelTagObj(index) {
      if (this.editLabelRuleData.executionConditionTagRuleItems.length == 1) {
        this.$Message.error(this.$t('BillingServices.keepAtLeastOne'));
        return;
      }
      this.editLabelRuleData.executionConditionTagRuleItems.splice(index, 1);
    },
    // 删除执行规则
    handleDelTagObj1(index) {
      if (this.editLabelRuleData.executionActionTagRuleItems.length == 1) {
        this.$Message.error(this.$t('BillingServices.keepAtLeastOne'));
        return;
      }
      this.editLabelRuleData.executionActionTagRuleItems.splice(index, 1);
    },
    // 云平台下拉框
    queryCloudPlatforms() {
      this.$api.originalBillEntry.queryCloudPlatforms().then(res => {
        this.CloudplatformtypeList = res.data;
      });
    },
    // 账单数据源下拉框
    queryAccountsByCompanyId() {
      if (this.editRuleData.cloudPlatformsType == undefined) {
        return;
      }
      this.$api.originalBillEntry
        .queryBillingAccountByCompanyId({
          companyId: this.editRuleData.companyId,
          cloudPlatformsType: this.editRuleData.cloudPlatformsType
        })
        .then(res => {
          this.BillingdatasourceList = res.data;
        });
    },
    // 标签规则下拉框
    queryBillingTagRule() {
      this.$api.originalBillEntry
        .queryBillingTagRule({ companyId: this.editRuleData.companyId })
        .then(res => {
          this.LabelRulesList = res.data;
        });
    }
  },
  mounted() {
    // 请求公司下拉框接口
    this.getCompanyDropDownBox();
    // 如果公司不是冠闵，处理table不显示公司名称一列
    if (this.companyId != 1) {
      this.dataDealColumns = this.dataDealColumns.filter(
        item => item.key != "companyName"
      );
    }
    // this.getDealData();
  }
};
</script>

<style scoped>
.ECMonitor-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/ebilling/OriginalBillEntry/BillingRules.vue